import type {ReactElement} from 'react';
import {Pill} from '@Components/pill/pill';
import {PillSize} from '@Components/pill/pill.types';
import {TextSize} from '@Components/text';
import {PostPublishStatus} from '@Libraries/social-media-publish-status.library';
import {assertNever} from '@Utils/assert-never.util';
import type {PostPublishStatusPillProps} from './post-publish-status-pill.types';
import {POST_PUBLISH_STATUS_PILL_GLYPHS, POST_PUBLISH_STATUS_PILL_TYPES} from './post-publish-status-pill.types';

export function PostPublishStatusPill({status, className = '', 'data-testid': dataTestId}: PostPublishStatusPillProps): ReactElement {
  const getPillLabel = (): string => {
    switch (status) {
      case PostPublishStatus.PUBLISHING:
        return window.i18next.t('pmwjs_publishing');
      case PostPublishStatus.PUBLISHED:
        return window.i18next.t('pmwjs_published');
      case PostPublishStatus.SCHEDULING:
        return window.i18next.t('pmwjs_scheduling');
      case PostPublishStatus.SCHEDULED:
        return window.i18next.t('pmwjs_scheduled');
      case PostPublishStatus.SAVING_DRAFT:
        return window.i18next.t('pmwjs_saving');
      case PostPublishStatus.SAVED_DRAFT:
        return window.i18next.t('pmwjs_draft');
      case PostPublishStatus.FAILED:
        return window.i18next.t('pmwjs_social_post_did_not_post');
      default:
        return assertNever(status);
    }
  };

  return <Pill label={getPillLabel()} type={POST_PUBLISH_STATUS_PILL_TYPES[status]} size={PillSize.SM} labelSize={TextSize.SM} icon={POST_PUBLISH_STATUS_PILL_GLYPHS[status]} className={className} data-testid={dataTestId} />;
}
